<template>
  <Modal
    :title="'Modifica situazione appuntamenti'"
    :openModal="openModal"
    :loading="loading"
    @close="close()"
    @success="save()"
  >
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_confirmed">Confermato</label>
          <div class="control">
            <input type="checkbox" id="bulk_confirmed" v-model="situation.confirmed">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_missing_documentation">Doc. mancante</label>
          <div class="control">
            <input type="checkbox" id="bulk_missing_documentation" v-model="situation.missing_documentation">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_receipt">Scontrino</label>
          <div class="control">
            <input type="checkbox" id="bulk_receipt" v-model="situation.receipt" :disabled="situation.to_invoice">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_to_invoice">Da fatturare</label>
          <div class="control">
            <input type="checkbox" id="bulk_to_invoice" v-model="situation.to_invoice" :disabled="situation.receipt">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet" v-show="situation.to_invoice">
        <div class="field">
          <label class="label" for="bulk_invoiced">Fatturato</label>
          <div class="control">
            <input type="checkbox" id="bulk_invoiced" v-model="situation.invoiced">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet" v-show="situation.to_invoice && situation.invoiced">
        <InputText name="Numero Fattura" v-model="situation.invoice_number" />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_paid">Pagato</label>
          <div class="control">
            <input type="checkbox" id="bulk_paid" v-model="situation.paid">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_no_due">Non deve nulla</label>
          <div class="control">
            <input type="checkbox" id="bulk_no_due" v-model="situation.no_due">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_to_fgas">Fare Fgas</label>
          <div class="control">
            <input type="checkbox" id="bulk_to_fgas" v-model="situation.to_fgas">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet" v-show="situation.to_fgas">
        <div class="field">
          <label class="label" for="bulk_fgas">Fgas</label>
          <div class="control">
            <input type="checkbox" id="bulk_fgas" v-model="situation.fgas">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_to_curmit">Fare Curmit</label>
          <div class="control">
            <input type="checkbox" id="bulk_to_curmit" v-model="situation.to_curmit">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet" v-show="situation.to_curmit">
        <div class="field">
          <label class="label" for="bulk_curmit">Curmit</label>
          <div class="control">
            <input type="checkbox" id="bulk_curmit" v-model="situation.curmit">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_exception">Eccezione</label>
          <div class="control">
            <input type="checkbox" id="bulk_exception" v-model="situation.exception">
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="field">
          <label class="label" for="bulk_controlled">Controllato</label>
          <div class="control">
            <input type="checkbox" id="bulk_controlled" v-model="situation.controlled">
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    selectedOperations: {
      type: Array,
      default: () => []
    }
  },

  emits: ['saved'],

  data() {
    return {
      openModal: false,
      loading: false,
      situation: this.emptySituation()
    }
  },

  methods: {
    emptySituation() {
      return {
        confirmed: false,
        missing_documentation: false,
        receipt: false,
        to_invoice: false,
        invoiced: false,
        invoice_number: '',
        paid: false,
        no_due: false,
        to_fgas: false,
        fgas: false,
        to_curmit: false,
        curmit: false,
        exception: false,
        controlled: false
      }
    },

    open() {
      if (!this.selectedOperations.length) {
        return
      }

      const first = this.selectedOperations[0]
      this.situation = {
        confirmed: !!first.confirmed,
        missing_documentation: !!first.missing_documentation,
        receipt: !!first.receipt,
        to_invoice: !!first.to_invoice,
        invoiced: !!first.invoiced,
        invoice_number: (first.invoice_number || '').toString(),
        paid: !!first.paid,
        no_due: !!first.no_due,
        to_fgas: !!first.to_fgas,
        fgas: !!first.fgas,
        to_curmit: !!first.to_curmit,
        curmit: !!first.curmit,
        exception: !!first.exception,
        controlled: !!first.controlled
      }

      this.openModal = true
    },

    close() {
      this.openModal = false
    },

    save() {
      if (!this.selectedOperations.length) {
        this.close()
        return
      }

      const ids = this.selectedOperations.map(operation => operation._id)

      this.loading = true
      this.$http.post('/operation/save-multiple-situation', {
        ids,
        situation: this.situation
      })
      .then(() => {
        this.loading = false
        this.close()
        this.$emit('saved')
      })
      .catch((error) => {
        console.log(error)
        alert('Errore')
        this.loading = false
      })
    }
  }
}
</script>
